/**
 * IremboGov 2.0 Compatibility Layer
 *
 * This module provides components and services for displaying
 * IremboGov 2.0 application data in IremboGov 3.0.
 *
 * @deprecated This module will be removed when Gov 2.0 is fully sunset
 */

// Models
export * from './models';

// Enums
export * from './enums';

// Pipes
export * from './pipes';

// Services
export * from './services';

// Components
export * from './components';

// Utils
export * from './utils';
